import { PropertyDefinitionsAPI } from 'api'

import { PropertyDefinition } from './types'

interface PropertyDefinitionResponse {
  results: PropertyDefinition[]
  totalResults: number
}
export const fetchPropertyDefinitions = () =>
  PropertyDefinitionsAPI.get<PropertyDefinitionResponse>(
    '/property_definitions?source=ACCOUNT&type=ENUM_STRING&type=STRING'
  )
